<!-- 页面右侧试题选项列表-->
<template>
  <div class="problem-controler-wrapper c-pd-ProblemControler">
    <div class="problem-controler-content">
      <div class="tiem" v-if="bankkeep">
        <span>
          <img alt src="@/assets/img/countdown@2x.png" />
          {{getDuration(useTimeSend)}}
        </span>
      </div>
      <div class="act-v" v-else>
        <p>习题收藏</p>
        <p class="act">全部共{{count}}道试题</p>
      </div>
      <!-- <div class="tiemOut" v-if="useTimeSend > 300">
   <span  > 考试最后剩余 :{{getDuration(useTimeSend)}}</span>
  
      </div>-->
      <div class="drill">
        <el-radio-group v-model="radio">
          <el-radio :label="1">当前试卷</el-radio>
          <el-radio :label="2">未答试题</el-radio>
          <el-radio :label="3">已答试题</el-radio>
        </el-radio-group>
      </div>
      <div class="answer_box">
        <div :key="index" class="problem-controler-single" v-for="(item, index) in answerList">
          <div class="answer_li" v-if="item.child.length > 0">
            <span>{{item.name}}</span>
            <span>共（{{ item.child.length }}）题</span>
            <section>
              <a
                :class="{ active: isActive === itm.examinationItemId }"
                :key="itm.order"
                :style="itm.select? 'color: #89BEFF;background-color:#E0F2FF': ''"
                @click="onClick(itm, itm.order)"
                class="common-trans"
                v-for="itm in item.child"
              >{{ itm.order }}</a>
            </section>
          </div>
        </div>
      </div>
      <div class="footer" v-if="bankkeep">
        <button @click="commitExam" class="commit-btn common-trans common-shadow">提交试卷</button>
      </div>
    </div>
  </div>
</template>
<script>
import * as dateUtil from '@/api/dateUtil'
export default {
  name: 'problemControler',
  props: ['selectData', 'is_submits', 'selectCount', 'type', 'count', "testTime", 'times', 'bankkeep'],
  data () {
    return {
      isActive: null,
      timeOut: '',
      is_submit: '',
      radio: 1,
      timer: null,
      useTimeSend: 0,
    }
  },
  components: {
    // countdown
  },
  created () {
    this.useTimeSend = this.times
    this.startime()
  },
  watch: {
    is_submits (val) {
      this.is_submit = val
    }
  },
  filters: {
    filterTime (val) {
      if (val < 10) {
        return '0' + val
      } else {
        return val
      }
    },
    timeFifter () {
      let m = ''
      let s = ''
      m = parseInt(this.time / 60)
      m = m >= 10 ? m : '0' + m
      s = this.num % 60
      s = s >= 10 ? s : '0' + s
      return m + ':' + s
    }
  },
  computed: {
    answerList () {
      let answerList = [
        {
          name: '单选题',
          child: []
        },
        {
          name: '多选题',
          child: []
        },
        {
          name: '判断题',
          child: []
        },
        {
          name: '简答题',
          child: []
        }
      ]
      if (this.radio === 1) {
        for (let i = 0; i < this.selectData.length; i++) {
          if (Number(this.selectData[i].questionType) === 1) {
            answerList[0].child.push(this.selectData[i])
          } else if (Number(this.selectData[i].questionType) === 2) {
            answerList[1].child.push(this.selectData[i])
          } else if (Number(this.selectData[i].questionType) === 3) {
            answerList[2].child.push(this.selectData[i])
          } else if (Number(this.selectData[i].questionType) === 4) {
            answerList[3].child.push(this.selectData[i])
          }
        }
      } else if (this.radio === 2) {
        for (let i = 0; i < this.selectData.length; i++) {
          if (
            Number(this.selectData[i].questionType) === 1 &&
            !this.selectData[i].select
          ) {
            answerList[0].child.push(this.selectData[i])
          } else if (
            Number(this.selectData[i].questionType) === 2 &&
            !this.selectData[i].select
          ) {
            answerList[1].child.push(this.selectData[i])
          } else if (
            Number(this.selectData[i].questionType) === 3 &&
            !this.selectData[i].select
          ) {
            answerList[2].child.push(this.selectData[i])
          } else if (
            Number(this.selectData[i].questionType) === 4 &&
            !this.selectData[i].select
          ) {
            answerList[3].child.push(this.selectData[i])
          }
        }
      } else if (this.radio === 3) {
        for (let i = 0; i < this.selectData.length; i++) {
          if (
            Number(this.selectData[i].questionType) === 1 &&
            this.selectData[i].select
          ) {
            answerList[0].child.push(this.selectData[i])
          } else if (
            Number(this.selectData[i].questionType) === 2 &&
            this.selectData[i].select
          ) {
            answerList[1].child.push(this.selectData[i])
          } else if (
            Number(this.selectData[i].questionType) === 3 &&
            this.selectData[i].select
          ) {
            answerList[2].child.push(this.selectData[i])
          } else if (
            Number(this.selectData[i].questionType) === 4 &&
            this.selectData[i].select
          ) {
            answerList[3].child.push(this.selectData[i])
          }
        }
      }
      return answerList
    },
    setTime () {
      let m = ''
      let s = ''
      m = parseInt(this.time / 60)
      m = m >= 10 ? m : '0' + m
      s = this.time % 60
      s = s >= 10 ? s : '0' + s
      return m + '分:' + s + '秒'
    }

  },



  methods: {
    startime: function () {
      this.timer = setInterval(() => {
        this.useTimeSend--
        sessionStorage.setItem('useTimeSend', this.useTimeSend)
        if (this.useTimeSend < 2) {
          this.$message.warning('倒计时快结束，两秒秒后自动交卷！')
          clearInterval(this.timer)
          setTimeout(() => {
            this.$emit('submitAnswer', true)
          }, 2000)
        }
      }, 1000);

    },

    //时间转换
    getDuration (val) {
      if (val) {
        return dateUtil.getDuration(val)
      }
    },

    // startimex(){
    //   setInterval(()=>{
    //     let ischange = false
    //     this.time++
    //     console.log('time :' +this.time)
    //     console.log('testtime :' +this.testTime)
    //     sessionStorage.setItem('time',this.time)
    //     if(this.testTime-this.time <10 &&! ischange  ){
    //        ischange =true
    //       this.$message.warning('倒计时已结束，两秒后自动交卷！')
    //       setTimeout(() => {
    //       this.$emit('submitAnswer', true)
    //       }, 2000)
    //     }

    //   },1000)
    // },
    onClick (item, index) {

      this.isActive = item.examinationItemId
      let active_an = {
        active: '#answer' + index,
        index
      }
      this.$addStorageEvent(0, 'active_an', JSON.stringify(active_an))
    },
    commitExam () {
      console.log(this.selectData.length)
      // let that = this
      let text = ''
      let btn = ''
      if (this.selectCount === this.selectData.length) {
        text = '您的题已全部答完，是否交卷'
        btn = '确定'
      } else {
        text = '即将交卷, 请检查所有题是否答完！！！'
        btn = '确认提交'
      }
      this.$confirm(text, '提示', {
        confirmButtonText: btn,
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('submitAnswer', true)
      }).catch(() => {

      })
    }
  },

  destroyed () {
    sessionStorage.removeItem('useTimeSend')
  }
}
</script>
<style lang="less" scoped>
.act-v {
  text-align: center;
  margin-top: 56px;
}
.act {
  padding: 12px;
  border-bottom: 1px solid #f2f2f2;
}
.c-pd-ProblemControler {
  @color: #36abff;
  .problem-controler-content {
    .tiem {
      display: flex;
      align-items: flex-start;
      color: #222222;
      font-size: 1rem;
      border-bottom: 1px solid #f0f1f2;
      margin-bottom: 0.5rem;
      align-items: center;
      height: 120px;
      justify-content: center;
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(71, 162, 255, 1);
      line-height: 35px;
      img {
        width: 1.5625rem;
        height: 1.5625rem;
        margin-top: 0.1rem;
        margin-right: 10px;
      }
    }

    .tiemOut {
      display: flex;
      align-items: flex-start;
      color: #222222;
      font-size: 1rem;
      border-bottom: 1px solid #f0f1f2;
      margin-bottom: 0.5rem;
      align-items: center;
      height: 120px;
      justify-content: center;
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgb(214, 16, 26);
      line-height: 35px;
      img {
        width: 1.5625rem;
        height: 1.5625rem;
        margin-top: 0.1rem;
        margin-right: 10px;
      }
    }

    .answer_box {
      width: 100%;
      height: 35.625rem;
      overflow-y: auto;
      margin-top: 20px;
      &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
        /**/
      }
      &::-webkit-scrollbar-track {
        background: rgb(239, 239, 239);
        border-radius: 2px;
      }
      &::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 10px;
      }
      .answer_tab {
        display: flex;
        color: #222;
        font-size: 1rem;
        margin-bottom: 2rem;
        div {
          width: 50%;
          display: inline-flex;
          justify-content: center;
          span {
            padding: 0.75rem 0;
            display: inline-block;
          }
        }
        .all,
        .allFalse {
          .active {
            color: #36abff !important;
            border-bottom: 0.125rem solid #36abff;
          }
        }
      }
      .problem-controler-single {
        padding: 0.25rem 1.5rem 1.75rem 1.5rem;
        section {
          list-style: none;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          a {
            color: #222222;
            width: 2.875rem;
            height: 2.875rem;
            border-radius: 50%;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            margin-right: 7%;
            font-size: 0.8rem;
            margin-top: 0.6rem;
            border: 1px solid #f5f5f5;
            &:hover {
              cursor: pointer;
              color: @color;
              border-color: @color;
            }
            // &:nth-child(5n+5) {
            //   margin-right: 0;
            // }
          }
          .active {
            color: #fff !important;
            border-color: @color;
            background-color: @color !important;
            a:hover,
            &:hover {
              color: #fff;
            }
          }
        }
      }
    }
    .footer {
      width: 100%;
      display: flex;
      margin-top: 30px;
      .commit-btn {
        color: #fff;
        outline: none;
        border: 0;
        width: 98px;
        height: 36px;
        background: linear-gradient(
          90deg,
          rgba(77, 205, 253, 1),
          rgba(71, 162, 255, 1)
        );
        border-radius: 4px;
        &:disabled {
          background-color: #bfbfbf;
        }
        cursor: pointer;
        &:focus {
          outline: none;
        }
        &:active {
          outline: none;
        }
      }
    }
  }
}
.drill {
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 4px solid #f2f2f2;
}
.nomore {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(187, 187, 187, 1);
  line-height: 22px;
  text-align: center;
}
.reanswer {
  outline: none;
  border: 0;
  width: 98px;
  height: 36px;
  background: #ffffff;
  color: rgba(51, 51, 51, 1);
  margin-left: 10px;
  cursor: pointer;
}
</style>
